import React,{useState,useEffect} from "react";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, ListSubheader } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import './AssignedToDropdownCell.css';
import { getUserMaintenanceList } from '../function-components/Redux/ProjectMasterSlice';
import { useDispatch, useSelector } from "react-redux";

const AssignedToDropdownCell = (props) => {
const { initialValue, onChange } = props;
const initialArray = initialValue ? initialValue.split(',') : [];
const [selectedMembers, setSelectedMembers] = useState(initialArray);
const userMaintenanceList = useSelector((state) => state.projectMaster.userMaintenanceList);
const dispatch = useDispatch();
const uniqueTeams = Array.from(new Set(userMaintenanceList.map((user) => user.team)));
const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
const useStyles = makeStyles({
    menuPaper: {
      display: 'flex',
      flexDirection: 'row',
      maxHeight: '300px !important',
      minwidth: 0,
      top: '275px !important',
      left: '960px !important'
    },
    column: {
      display: 'flex',
      flexDirection: 'column',      
    },
    header: {
      fontWeight: 'bold',
      backgroundColor: theme.palette.background.paper,
      fontSize: '16px',
      color: '#AD21FF'
    },
  });

const classes = useStyles();

// const handleChange = (event) => {
//     const newValue = event.target.value;
//     let newMember = newValue[0];
//     console.log(newMember,"newMember")
//     let result =  newValue.slice(1);
//     let newResultedArray = newMember.split(",");
//     result.push(...newResultedArray);
//     let newString = result.join(',')
//     let finalResult = [];
//     finalResult.push(newString);
//     console.log(result,"res")
//     console.log(finalResult,"finalResult")
//     console.log(selectedMembers,"selMem")
//     setSelectedMembers(result);
//   };


  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedMembers(newValue);
    onChange(newValue); // Call the onChange callback to update the data in your parent component
  };

  // useEffect(() => {
  //   dispatch(getUserMaintenanceList());
  // }, []);


const teams = {
        Development: ['Aayushi', 'Akash', 'Ankur', 'Arpita', 'Deepak', 'Jyoti', 'Lavanya','Rajath', 'Reshmi','Shramika','Uma'],
        Design: ['Avijit','Manasa','Manoj','Medha','Vinay'],
        PowerBI: ['Akshata','Deepa']
      };


    return (
        <>
        <FormControl fullWidth>
        <Select className="team_member_dropdown"   
              multiple
              value={selectedMembers}
              onChange={handleChange}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >                    
            {uniqueTeams
            .filter((team) =>
            userMaintenanceList.some(
              (user) => user.team === team && user.action === 'Active' 
              )
              )
             .map((team) => (
             <div key={team}>
              <ListSubheader className="subheader_dropdown">{team}</ListSubheader>
              {userMaintenanceList
                .filter((user) => user.team === team && user.action === 'Active')
                .map((user) => (
                  <MenuItem key={user.id} value={user.username}>
                    <Checkbox
                      checked={selectedMembers.includes(user.username)}
                      onChange={() => {
                        const newSelectedValues = selectedMembers.includes(user.username)
                          ? selectedMembers.filter((value) => value !== user.username)
                          : [...selectedMembers, user.username];
                          setSelectedMembers(newSelectedValues);
                        onChange(newSelectedValues);
                      }}
                    />
                    <ListItemText primary={user.username} />
                  </MenuItem>
                ))}
              </div>
                ))}
                </Select>
                </FormControl>
            </>
    )
}

export default AssignedToDropdownCell;